import ShareMsgBase from './A_G.ShareMsgBase';

class MsgHardLevelComplete extends ShareMsgBase {
  /**
   * The message that is shared when you beat a hard level and you want to brag
   * @param {string} user1AvatarURL
   * @param {string} userName
   * @param {number} lvlIndex
   * @param {function} onAllImagesReadyCallback
   */
  constructor(user1AvatarURL, userName, lvlIndex, onAllImagesReadyCallback = null) {
    super(3, onAllImagesReadyCallback);

    this.avatar1 = this._addExtImage(249, 78, user1AvatarURL, 0, 190, null);
    this.bg = this._addExtImage(0, 0, 'img/Share_Hard_Level_Complete.png', 0, null, null);

    const beatLvlStr = OMT.language.getText('%NAME% beat a hard level!').replace('%NAME%', userName);
    this.beatLvlTxt = new G.Text(343, 320, beatLvlStr, 'msg-yellow-2', 0.5, 400);
    this.add(this.beatLvlTxt);
    this.beatLvlTxt.addColor('#ffffff', userName.length);

    this.levelTxtGroup = new Phaser.Group(game, this);
    this.levelMasterTxt = new G.Text(565, 82, OMT.language.getText('Level Master!'), 'msg-purpleFontStyle', 0.5, 190);
    this.levelTxt = new G.Text(565, 148, OMT.language.getText('Level'), 'msg-purpleFontStyle', 0.5, 110);
    this.levelNumberTxt = new G.Text(565, 215, lvlIndex.toString(), {
      style: 'msg-purpleFontStyle',
      fontSize: '90px',
    }, 0.5, 110);
    this.levelTxtGroup.add(this.levelMasterTxt);
    this.levelTxtGroup.add(this.levelTxt);
    this.levelTxtGroup.add(this.levelNumberTxt);

    this._objectLoadComplete();
  }
}

G.MsgHardLevelComplete = MsgHardLevelComplete;
